import { useState } from 'react';
import { faqData } from '@/mocks/faq';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map(item => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            常见问题
          </h2>
          <p className="text-foreground-500 mt-2 text-sm md:text-base">
            快速了解玖玖视频的常见问题
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="rounded-lg border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer hover:bg-background-100 transition-colors"
                aria-expanded={openIndex === index}
              >
                <span className="text-sm md:text-base font-heading font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <div className={`w-5 h-5 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-45' : ''}`}>
                  <i className="ri-add-line text-foreground-500"></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}